export const columns = function () {
  // 机构名称，出单数量，公户（河北车益保汽车服务有限公司）收入，公户（河北车益保汽车服务有限公司卢龙分公司）收入，公户（辽宁车益保汽车科技有限公司）收入，公户（河北车益保汽车服务有限公司）聚合码收入，公户（河北车益保汽车服务有限公司卢龙分公司）聚合码收入，公户（辽宁车益保汽车科技有限公司）聚合码收入，其他收入（元），合计收入（元）
  return [
    {
      prop: "orgName",
      label: "机构名称",
      minWidth: 200,
    },
    {
      prop: "outNum",
      label: "出单数量",
      minWidth: 100,
    },
    {
      prop: "gh_amount",
      label: "公户收入(元)",
      sortable: true,
      minWidth: 200,
    },
    {
      prop: "wx_qrcode_amount",
      label: "微信收入(元)",
      sortable: true,
      minWidth: 200,
    },
    {
      prop: "other_amount",
      label: "其他收入(元)",
      minWidth: 200,
    },
    {
      prop: "pay_money",
      label: "扫码收入(元)",
      minWidth: 200,
    },
    {
      prop: "realInFee",
      label: "收入合计(元)",
      minWidth: 100,
    },
  ];
};

export default {};
